import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function Terms() {
  useEffect(() => {
    document.title = 'Términos y Condiciones | CodeLiance';
  }, []);

  return (
    <div className="min-h-screen bg-[#050608]">
      <Navbar />
      
      <section className="pt-32 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-black text-white mb-8">
            Términos y <span className="text-[#00C2FF]">Condiciones</span>
          </h1>
          
          <p className="text-gray-400 mb-8">
            Última actualización: {new Date().toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Aceptación de Términos</h2>
              <p>
                Al acceder y utilizar el sitio web de CodeLiance, usted acepta cumplir con estos términos y condiciones. Si no está de acuerdo con alguna parte de estos términos, le solicitamos que no utilice nuestro sitio web.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Licencia de Uso</h2>
              <p>
                Se le otorga una licencia limitada, no exclusiva e intransferible para acceder y utilizar el sitio web únicamente para propósitos comerciales legales. Está prohibido:
              </p>
              <ul className="mt-4 list-disc list-inside space-y-2">
                <li>Reproducir, distribuir o transmitir cualquier contenido</li>
                <li>Realizar ingeniería inversa o acceso no autorizado</li>
                <li>Usar bots, scrapers o herramientas automáticas</li>
                <li>Interferir con la operación normal del sitio</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Contenido del Usuario</h2>
              <p>
                Si usted envía, publica o muestra contenido a través de nuestro sitio, otorga a CodeLiance una licencia mundial, royalty-free para usar, reproducir y modificar ese contenido con propósitos comerciales.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Descargo de Responsabilidad</h2>
              <p>
                El sitio web se proporciona "tal cual" sin garantías de ningún tipo, ya sean expresas o implícitas. CodeLiance no garantiza que:
              </p>
              <ul className="mt-4 list-disc list-inside space-y-2">
                <li>El sitio esté libre de errores o interrupciones</li>
                <li>El contenido sea preciso, completo o actual</li>
                <li>Los virus o componentes dañinos estén ausentes</li>
                <li>Los resultados cumplan con sus expectativas</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Limitación de Responsabilidad</h2>
              <p>
                En ningún caso CodeLiance será responsable por daños incidentales, especiales, indirectos o consecuentes que surjan del uso o imposibilidad de usar el sitio web o sus servicios, incluso si se ha asesorado de la posibilidad de tales daños.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Propiedad Intelectual</h2>
              <p>
                Todo el contenido del sitio web, incluyendo textos, gráficos, logos, imágenes y software, es propiedad de CodeLiance o sus proveedores de contenido y está protegido por leyes de derechos de autor internacionales.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Enlaces Externos</h2>
              <p>
                CodeLiance no es responsable por el contenido de sitios web externos enlazados desde nuestro sitio. La presencia de un enlace no implica endoso de ningún sitio externo.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Modificación de Términos</h2>
              <p>
                CodeLiance se reserva el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación. Su uso continuado del sitio constituye su aceptación de los términos modificados.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Terminación</h2>
              <p>
                CodeLiance puede terminar o suspender el acceso a su cuenta o servicio sin previo aviso si viola estos términos o por cualquier razón que CodeLiance determine a su exclusivo criterio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Ley Aplicable</h2>
              <p>
                Estos términos y condiciones se rigen por las leyes de Colombia. Cualquier disputa se resolverá en los juzgados competentes de Colombia.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">11. Contacto</h2>
              <p>
                Si tiene preguntas sobre estos términos, por favor contáctenos en:
              </p>
              <ul className="mt-4 space-y-2">
                <li>📧 Email: comercial@codeliance.co</li>
                <li>📱 Teléfono: +57 301 740 0570</li>
                <li>🌐 Web: https://codeliance.co</li>
              </ul>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
